import { createContext, useState } from "react";

export const MembershipContext = createContext();

const MembershipProvider = ({ children }) => {
  const [filterPlans, setFilterPlans] = useState({
    countryCode: "",
    currencyCode: "",
    countryId: "",
  });

  const [selectedPlan, setSelectedPlan] = useState({});

  return (
    <MembershipContext.Provider
      value={{
        filterPlans,
        setFilterPlans,
        selectedPlan,
        setSelectedPlan,
      }}
    >
      {children}
    </MembershipContext.Provider>
  );
};

export default MembershipProvider;
